/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface ISocketConnectMessage extends IMessage {
	id: string;
	userId?: string;
	role?: string;
	permissions?: string[];
}

export default class SocketConnectMessage extends Message {
	public static readonly TYPE: string = '32';

	public static readonly READABLE_TYPE_NAME: string = 'connectSocket';

	public static readonly DESCRIPTOR_NAME: string = 'SocketConnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			userId: {
				type: 'string',
				id: 2
			},
			role: {
				type: 'string',
				id: 3
			},
			permissions: {
				rule: 'repeated',
				type: 'string',
				id: 4
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly userId?: string,
		public readonly role?: string,
		public readonly permissions?: string[]
	) {
		super();
	}

	public toJSON(): ISocketConnectMessage {
		return {
			id: this.id,
			userId: this.userId ?? undefined,
			role: this.role ?? undefined,
			permissions: this.permissions ?? undefined
		};
	}

	public static fromJSON( data: ISocketConnectMessage ): SocketConnectMessage {
		return new SocketConnectMessage( data.id, data.userId, data.role, data.permissions );
	}
}
